export function selectStyle(user) {
  return {
    option: () => ({}),
    control: () => ({})
  }
}
